module.exports = __webpack_public_path__ + "img/ic_login_title.9702a754.png";